import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'content-selector-preview',
  template: `
    <div class="item-left">
      <ng-content></ng-content>
    </div>
    <div class="item-right item-metadata-list">
      @if (!loaded()) {
        <div class="item-metadata-row">
          <loading-rect size="100% 25px"></loading-rect>
        </div>
        <div class="item-metadata-row">
          <loading-rect size="100% 25px"></loading-rect>
        </div>
        <div class="item-metadata-row">
          <loading-rect size="100% 25px"></loading-rect>
        </div>
        <div class="item-metadata-row">
          <loading-rect size="100% 25px"></loading-rect>
        </div>
        <div class="item-metadata-row">
          <loading-rect size="100% 25px"></loading-rect>
        </div>
        <div class="item-metadata-row">
          <loading-rect size="100% 25px"></loading-rect>
        </div>
      }
      @else {
        @for (m of metadata(); track m) {
          <div class="item-metadata-row item-metadata-{{m.name}}">
            <div class="item-metadata-title text-ellipsis" [title]="m.name">{{m.name}}</div>
            <div class="item-metadata-value">
              @for (v of m.value; track v) {
                <div class="item-metadata-value-row" [title]="v.tooltip ?? v.title">
                  <span [innerHTML]="v.title"></span>
                  @if (!$last) { <span>, </span> }
                </div>
              }
            </div>
          </div>
        }
      }
  `,
  styles: `
    :host {
      display: contents;
    }
    
    .item-left {
      padding: 4px;
      box-sizing: border-box; 
      min-width: 400px;
      width: 400px;
    }
    
    .item-right {
      padding: 10px;
      box-sizing: border-box; 
      overflow: hidden auto;
    }

    .item-metadata-list {
      display: flex;
      flex-direction: column; 
    }

    .item-metadata-row {
      display: block;
      margin-bottom: 10px;
    }

    .item-metadata-title {
      font-weight: bold;
    }

    .item-metadata-value {
    }

    .item-metadata-value-row {  
      white-space: pre-wrap;
      text-overflow: ellipsis;
      overflow: hidden;  
      display: inline-block;
      user-select: all;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContentSelectorPreviewComponent {
  readonly loaded = input(false);
  readonly metadata = input<ReadonlyArray<ItemMetadata>>([]);
}

export type ItemMetadataValue = {
  title: string;
  tooltip?: string;
  invalid?: boolean;
};

export class ItemMetadata {
  constructor(
    readonly name: string,
    readonly value: ReadonlyArray<ItemMetadataValue>) { }
}
